import React from 'react';

export const Avatar = ({ name, url, size = '36px', isOnline }: { name: string, url?: string, size?: string, isOnline?: boolean }) => {
  const safeName = name || 'User';
  const initials = safeName.split(' ').map(n => n?.[0] || '').join('').slice(0, 2).toUpperCase();
  const hash = safeName.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const hue = hash % 360;
  
  return (
    <div className="relative inline-flex shrink-0" style={{ width: size, height: size }}>
      {url ? (
        <img src={url} alt={name} className="w-full h-full rounded-full object-cover shadow-sm" />
      ) : (
        <div 
          className="w-full h-full rounded-full flex items-center justify-center text-white font-medium shadow-[inset_0_1px_4px_rgba(255,255,255,0.4),0_1px_2px_rgba(0,0,0,0.1)]"
          style={{ 
            background: `linear-gradient(135deg, hsl(${hue}, 85%, 65%), hsl(${hue + 30}, 90%, 55%))`,
            fontSize: parseInt(size) * 0.4
          }}
        >
          <span style={{ textShadow: '0 1px 2px rgba(0,0,0,0.15)' }}>{initials}</span>
        </div>
      )}
      {isOnline !== undefined && (
        <span 
          className="absolute bottom-0 right-0 rounded-full border-2 border-white shadow-sm"
          style={{
            width: Math.max(10, parseInt(size) * 0.28),
            height: Math.max(10, parseInt(size) * 0.28),
            backgroundColor: isOnline ? '#34C759' : '#C7C7CC'
          }}
        />
      )}
    </div>
  );
};

export const Badge = ({ children, color = 'blue' }: { children: React.ReactNode, color?: 'blue' | 'red' | 'gray' }) => {
  const styles = {
    blue: 'bg-[#007AFF] text-white',
    red: 'bg-[#FF3B30] text-white',
    gray: 'bg-[#8E8E93] text-white'
  };
  return (
    <span className={`inline-flex items-center justify-center px-1.5 h-5 min-w-[20px] rounded-full text-[11px] font-bold ${styles[color]}`}>
      {children}
    </span>
  );
};

export const Pill = ({ children, type }: { children: React.ReactNode, type?: 'open' | 'pending' | 'closed' | 'high' | 'medium' | 'low' | 'tag' | 'ghost' }) => {
  const styles = {
    open: 'bg-[#34C759]/10 text-[#248A3D] border border-[#34C759]/20',
    pending: 'bg-[#FF9500]/10 text-[#B26800] border border-[#FF9500]/20',
    closed: 'bg-[#8E8E93]/10 text-[#636366] border border-[#8E8E93]/20',
    high: 'bg-[#FF3B30]/10 text-[#C93400] border border-[#FF3B30]/20',
    medium: 'bg-[#FF9500]/10 text-[#B26800] border border-[#FF9500]/20',
    low: 'bg-[#007AFF]/10 text-[#0056B3] border border-[#007AFF]/20',
    tag: 'bg-white text-[#8E8E93] border border-black/5 shadow-sm hover:text-black transition-colors',
    ghost: 'bg-transparent text-[#8E8E93] border border-dashed border-black/20'
  };

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[12px] font-semibold tracking-wide ${styles[type || 'tag']}`}>
      {children}
    </span>
  );
};
